import { Grid, Typography as Type } from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import LeftSideNav from "../../../Components/LeftSideNav";
import TopNavBar from "../../../Components/TopNavbar";
import Fonts from "../../../Config/Fonts";
import Icons from "../../../Config/Images";
import Colors from "../../../theme/Colors";
import { UploadMediaRequestAPI } from "../../../Store/Action/mediaAction";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { Helmet } from "react-helmet-async";

// Component for displaying each user detail item
const DetailItem = ({ label, value }) => (
  <Grid
    item
    xs={8}
    sm={14}
    style={{
      display: "flex",
      alignItems: "center",
      padding: "6px 0",
      width: "28vw",
    }}
  >
    <Type variant="subtitle1" style={labelInfoStyle}>
      <div>{label}</div>
    </Type>
    <Type
      style={{
        width: "120%",
        maxWidth: "550px",
        justifyContent: "start",
        display: "flex",
      }}
    >
      <div style={inputTextStyle}>
        :
        <p
          style={{
            fontSize: 16,
            fontWeight: "400",
            fontFamily: Fonts.Poppins,
            color: Colors.darkGray,
            marginLeft: "5px",
          }}
        >
          {value}
        </p>
      </div>
    </Type>
  </Grid>
);

const BottomDetailItem = ({ label, value }) => (
  <Grid
    item
    xs={9}
    sm={18}
    style={{
      display: "flex",
      alignItems: "center",
      padding: "8px 0",
      width: "30vw",
    }}
  >
    <Type variant="subtitle1" style={labelInfoStyle}>
      <div>{label}</div>
    </Type>
    <Type
      style={{
        width: "100%",
        justifyContent: "start",
        display: "flex",
      }}
    >
      <div style={inputTextStyle}>
        :
        <p
          style={{
            fontSize: 16,
            fontWeight: "400",
            fontFamily: Fonts.Poppins,
            color: Colors.darkGray,
            marginLeft: "5px",
          }}
        >
          {value}
        </p>
      </div>
    </Type>
  </Grid>
);

const LessWeightBreakdown = ({ details }) => {
  console.log("detailsdetailsdetails");
  console.log(details);
  if (!details?.length) return null;

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "6px",
        marginTop: "4px",
      }}
    >
      {details.map((d) => (
        <span
          key={d.product_less_weight_detail_id}
          style={{
            fontSize: 13,
            fontFamily: Fonts.Poppins,
            color: Colors.darkGray,
            backgroundColor: "#F3F3F3",
            padding: "2px 8px",
            borderRadius: 12,
          }}
        >
          {d.product_component_type_name}: {d.weight_value}g
        </span>
      ))}
    </div>
  );
};
const ProductDetails = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { product } = location?.state || {};
  const [imageSrc, setImageSrc] = useState("");
  const inputRef = useRef();
  const [breadcrumbs, setBreadcrumbs] = useState([]);

  const handleImageChange = useCallback(
    (e) => {
      const files = e.target.files;
      const file = files[0];
      const newImageSrc = URL.createObjectURL(file);
      setImageSrc(newImageSrc); // Set the image URL for display

      const newProductImg = Array.from(files); // Convert FileList to array
      const isMultiple = newProductImg.length > 1;
      dispatch(
        UploadMediaRequestAPI(
          newProductImg,
          "files",
          isMultiple,
          (isSuccess, response) => {
            if (isSuccess?.status === true) {
              toast.success(response?.data?.message);
            } else {
              toast.error(response?.error?.message);
            }
          },
        ),
      );
    },
    [dispatch], // Add 'dispatch' to dependency array
  );

  useEffect(() => {
    if (product && product.product_name) {
      setBreadcrumbs([
        { key: "1", href: "/productList", text: "Products" },
        { key: "2", href: `/`, text: "Product Detail" },
      ]);
    }
  }, [product]);

  return (
    <>
      <Helmet>
        <title>{product?.product_name || "Product"} | Zabali</title>

        <meta
          name="description"
          content={
            product?.product_name +
              " - Buy " +
              product?.product_category_name +
              " online from Zabali" || "Buy premium jewelry on Zabali"
          }
        />

        <meta property="og:title" content={product?.product_name} />

        <meta
          property="og:description"
          content={`${product?.product_category_name} | ${product?.product_metal_name} | ${product?.product_stamp_value}`}
        />

        <meta
          property="og:image"
          content={product?.product_image?.[0]?.product_image_url}
        />

        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="product" />

        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "20% 90%",
          height: "100vh",
          width: "100vw",
          overflowX: "hidden",
          overflowY: "hidden",
        }}
      >
        <LeftSideNav />

        <div
          style={{
            display: "grid",
            backgroundColor: Colors.bgColor,
          }}
        >
          <div style={{ width: "85%" }}>
            <TopNavBar leftSideText={"Product Detail"} />
            <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
          </div>

          <div
            style={{
              width: "82%",
              height: "82vh",
              backgroundColor: Colors.white,
              marginLeft: "28px",
              borderRadius: 6,
              padding: 10,
            }}
          >
            <h1 style={mainHeadingStyle}>Product Information</h1>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "65% 35%",
              }}
            >
              <div
                style={{
                  width: "98%",
                  height: "100%",
                  padding: 20,
                  display: "flex",
                }}
              >
                <div style={{ width: "50%" }}>
                  <Grid
                    container
                    spacing={2}
                    style={{ marginTop: "5px", marginLeft: "5px" }}
                  >
                    <DetailItem label="Brand" value={product?.product_name} />
                    <DetailItem
                      label="Category"
                      value={product?.product_category_name || "Nil"}
                    />
                    <DetailItem
                      label="Sub Category"
                      value={product?.product_subcategory}
                    />
                    <DetailItem
                      label="Description"
                      value={product?.product_description || "Nil"}
                    />
                  </Grid>
                </div>

                <div style={{ width: "40%" }}>
                  <Grid container spacing={2} style={{ marginTop: "5px" }}>
                    <DetailItem
                      label="Product Name"
                      value={product?.product_name}
                    />
                    <DetailItem
                      label="Product Code"
                      value={product?.product_category_name || "Nil"}
                    />
                    <DetailItem
                      label="Product Metal"
                      value={product?.product_subcategory}
                    />
                  </Grid>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                <div
                  style={{
                    height: "100%",
                    width: "100%",
                    marginRight: 20,
                    borderRadius: "4px",
                    border: "1px dashed #D3D3D3",
                    cursor: "pointer",
                    display: "flex",
                    overflow: "hidden",
                    padding: 10,
                    marginTop: "10px",
                  }}
                >
                  <div style={{ width: "50%", height: "100%" }}>
                    {imageSrc ? (
                      <img
                        src={imageSrc}
                        alt="Selected"
                        style={imageStyle}
                        loading="lazy"
                      />
                    ) : (
                      <div
                        style={{
                          flexDirection: "column",
                          border: "1px solid #D3D3D3",
                          marginRight: "10px",
                          height: "30vh",
                          width: "95%",
                          borderRadius: "4px",
                          justifyContent: "center",
                          alignItems: "center",
                          display: "flex",
                        }}
                      >
                        <img
                          src={Icons.uploadImageIcon}
                          alt="Upload icon"
                          loading="lazy"
                          style={uploadIconStyle}
                        />
                        <input
                          type="file"
                          ref={inputRef}
                          multiple
                          style={{ display: "none" }}
                          onChange={(e) => handleImageChange(e)}
                        />
                      </div>
                    )}
                  </div>

                  <div
                    style={{
                      width: "50%",
                      height: "100%",
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, 1fr)",
                        gap: "10px",
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      {Array(6)
                        .fill("")
                        .map((_, index) => (
                          <div
                            key={index}
                            style={{
                              width: "100%",
                              height: "74px",
                              backgroundColor: Colors.white,
                              border: "1px solid #D3D3D3",
                              borderRadius: 4,
                              position: "relative", // Set position to relative for proper icon positioning
                              display: "flex", // Center the icon within the div
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            {/* Add Plus Icon Here */}
                            <img
                              src={Icons.addImageIcon} // Ensure this is correctly defined or imported
                              alt="Add icon"
                              style={{ height: "24px", width: "24px" }}
                            />
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{
                height: "45%",
                width: "100%",
                borderRadius: "10px",
                marginLeft: "10px",
              }}
            >
              <h1 style={mainHeadingStyle}>Additional Information</h1>
              <div
                style={{ width: "98%", display: "flex", marginLeft: "15px" }}
              >
                <div style={{ width: "36%", marginTop: 15 }}>
                  <BottomDetailItem
                    label="Gross Weight"
                    value={product?.product_gross_weight}
                  />
                  <BottomDetailItem
                    label="Less Weight"
                    value={product?.product_less_weight || "Nil"}
                  />
                  <BottomDetailItem
                    label="Less Weight"
                    value={product?.product_less_weight || "Nil"}
                  />
                  <LessWeightBreakdown
                    details={product?.product_less_weight_details}
                  />
                  <BottomDetailItem
                    label="Net Weight"
                    value={product?.product_net_weight || "Nil"}
                  />
                  <BottomDetailItem
                    label="Product Quantity"
                    value={product?.product_quantity || "Nil"}
                  />
                  <BottomDetailItem
                    label="Product Stamp"
                    value={product?.product_less_weight}
                  />
                  <BottomDetailItem
                    label="Product Melting"
                    value={product?.product_less_weight || "Nil"}
                  />
                </div>

                <div style={{ width: "36%", marginTop: 15 }}>
                  <BottomDetailItem
                    label="labour of Retailer"
                    value={product?.product_gross_weight}
                  />
                  <BottomDetailItem
                    label="Wastage for Retailer"
                    value={product?.product_less_weight || "Nil"}
                  />
                  <BottomDetailItem
                    label="Rate"
                    value={product?.product_net_weight || "Nil"}
                  />
                  <BottomDetailItem
                    label="Per Pcs for Retailer"
                    value={product?.product_quantity || "Nil"}
                  />
                  <BottomDetailItem
                    label="Minimum Quantity"
                    value={product?.product_less_weight}
                  />
                </div>

                <div style={{ width: "36%", marginTop: 15 }}>
                  <BottomDetailItem
                    label="labour of wholesaler"
                    value={product?.product_gross_weight}
                  />
                  <BottomDetailItem
                    label="Wastage for wholesaler"
                    value={product?.product_less_weight || "Nil"}
                  />
                  <BottomDetailItem
                    label="Rate"
                    value={product?.product_net_weight || "Nil"}
                  />
                  <BottomDetailItem
                    label="Per Pcs for wholesaler"
                    value={product?.product_quantity || "Nil"}
                  />
                  <BottomDetailItem
                    label="Minimum Quantity"
                    value={product?.product_less_weight}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mainHeadingStyle = {
  fontSize: 24,
  fontWeight: "500",
  fontFamily: Fonts.Poppins,
  color: Colors.black,
  display: "flex",
  padding: "5px",
  borderBottom: "1px solid #d3d3d3",
};

const labelInfoStyle = {
  fontSize: 16,
  fontWeight: "500",
  fontFamily: Fonts.Poppins,
  color: Colors.black,
  display: "flex",
  alignItems: "center",
  width: "80%",
};

const inputTextStyle = {
  fontSize: 16,
  fontWeight: "400",
  fontFamily: Fonts.Poppins,
  color: Colors.darkGray,
  display: "flex",
  alignItems: "center",
  width: "100%",
};

const imageStyle = {
  height: "98%",
  width: "94%",
  objectFit: "cover",
  border: "1px solid #D3D3D3",
  borderRadius: 4,
};

const uploadIconStyle = {
  height: "40px",
  width: "40px",
};

export default ProductDetails;
